// API de evidencia fotográfica de la entrega (carga / entregada / acuse físico).
import { api } from './api'
import type { DataResponse, Evidence, EvidenceStage, PaginatedResponse } from '@/types'

export type { Evidence }

export interface EvidenceMeta {
  stage: EvidenceStage
  taken_at: string
  latitude?: number | null
  longitude?: number | null
  notes?: string | null
}

export async function listEvidence(deliveryId: string) {
  const { data } = await api.get<PaginatedResponse<Evidence>>(`/deliveries/${deliveryId}/evidence`)
  return data
}

export async function uploadEvidence(deliveryId: string, file: Blob, meta: EvidenceMeta) {
  const form = new FormData()
  form.append('file', file, `evidence-${meta.stage}.jpg`)
  form.append('stage', meta.stage)
  form.append('taken_at', meta.taken_at)
  if (meta.latitude != null) form.append('latitude', String(meta.latitude))
  if (meta.longitude != null) form.append('longitude', String(meta.longitude))
  if (meta.notes) form.append('notes', meta.notes)
  const { data } = await api.post<DataResponse<Evidence>>(
    `/deliveries/${deliveryId}/evidence`,
    form,
  )
  return data.data
}

/** Borra una foto subida por error (quien la subió, mientras la entrega siga en curso). */
export async function deleteEvidence(deliveryId: string, evidenceId: string) {
  await api.delete(`/deliveries/${deliveryId}/evidence/${evidenceId}`)
}

export const STAGE_LABEL: Record<EvidenceStage, string> = {
  carga: 'Carga al camión',
  entrega: 'Mercancía entregada',
  acuse: 'Acuse físico',
}
